import { Location } from '../types';

export abstract class LocationService {
    public abstract search(term: string): Promise<Location[]>;
}
